import React, {useState, useEffect} from 'react'
import SubHeader from '../general/SubHeader';
import { useNavigate } from 'react-router-dom';
import EmptyTask from '../assets/empty-task.gif';
import Loading from '../general/Loading';
import Select from 'react-select';

const TourPackage = () => {
    const [myPackage, setMyPackage] = useState([]);
    const [expand, setExpand] = useState({});
    const [showBook, setShowBook] = useState(false);
    const [selectedPkg, setSelectedPkg] = useState('');
const [bookingForm, setBookingForm] = useState({ name: '', mobile: '', email: '', person: '', total_price: 0, booking_on: '' });
      const [responseMessage, setResponseMessage] = useState('');
const [loading, setLoading] = useState(false);
const [filteredPackages, setFilteredPackages] = useState([]);
const [startOptions, setStartOptions] = useState([]);
const [endOptions, setEndOptions] = useState([]);
const [selectedStart, setSelectedStart] = useState(null);
const [selectedEnd, setSelectedEnd] = useState(null);


// const navigate = useNavigate();

//   const formatDateTime = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleString('en-GB', {
//       day: '2-digit',
//       month: 'short',
//       year: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true
//     }).replace(',', '');
//   };

  
          useEffect(() => {
            
            const fetchPackage = async () => {
              setLoading(true);
              try {
                const response = await fetch('https://api.shaktitours.com/get-package');
                const data = await response.json();
        
                if (response.ok) {
              setLoading(false);
              const uniqueStart = [...new Set(data.map(pkg => pkg.start_point))];
const uniqueEnd = [...new Set(data.map(pkg => pkg.dest_point))];

setStartOptions(uniqueStart.map(point => ({ value: point, label: point })));
setEndOptions(uniqueEnd.map(point => ({ value: point, label: point })));
setFilteredPackages(data);

                  setMyPackage(data);
                } else {
              setLoading(false);
                  console.error('Failed to fetch enquiries:', data);
                }
              } catch (error) {
              setLoading(false);
                console.error('Error while fetching enquiries:', error);
              }
            };
        
            fetchPackage();
          }, []); 
    

const handleSearch = () => {
  const filtered = myPackage.filter(pkg => {
    const matchStart = selectedStart ? pkg.start_point === selectedStart.value : true;
    const matchEnd = selectedEnd ? pkg.dest_point === selectedEnd.value : true;
    return matchStart && matchEnd;
  });

  setFilteredPackages(filtered);
};


const toggleSection = (pkgId, section) => {
  setExpand((prev) => ({
    ...prev,
    [pkgId]: {
      sightseeing: false,
      meal: false,
      accomodation: false,
      [section]: !prev[pkgId]?.[section],
    },
  }));
};

const handleShowBook = (pkg) => {
  setSelectedPkg(pkg);
  setShowBook(true);
}

useEffect(() => {
  if (!selectedStart && !selectedEnd) {
    setFilteredPackages(myPackage);
  }
}, [selectedStart, selectedEnd]);


useEffect(() => {
  if (selectedPkg && bookingForm.person && !isNaN(bookingForm.person)) {
    const total = selectedPkg.price * parseInt(bookingForm.person);
    setBookingForm((prev) => ({
      ...prev,
      total_price: total
    }));
  }
}, [bookingForm.person, selectedPkg]);


  return (
    <>
            <SubHeader message='Tour Package' />

          <section className='my-5'>
        <div className='container'>

<div className="row align-items-center text-center">
  <div className="col-lg-4 col-md-4 col-sm-5 mb-2 text-start">
    <label className="package-label fw-semibold">Start Point</label>
    <Select
      options={startOptions}
      isClearable
      placeholder="Select Start Point"
      value={selectedStart}
      onChange={setSelectedStart}
    />
  </div>
  <span className='col-lg-2 col-md-1 col-sm-2 col-12'>
  <i class="fa-solid fa-arrow-right-arrow-left fs-3 text-dark"></i></span>
  <div className="col-lg-4 col-md-4 col-sm-5 mb-2 text-start">
    <label className="package-label fw-semibold">End Point</label>
    <Select
      options={endOptions}
      isClearable
      placeholder="Select End Point"
      value={selectedEnd}
      onChange={setSelectedEnd}
    />
  </div>
  <div className="col-lg-2 col-md-3 mt-3">
    <button className="nav-btn bg-black w-100" onClick={handleSearch}>
      <i className="fa-solid fa-magnifying-glass"></i> Search
    </button>
  </div>
</div>
{/* <button className='nav-btn bg-black' onClick={() => navigate('/add-package')}><i class="fa-solid fa-plus"></i> Add New Package</button> */}

<div className='row mt-4'>

                      {filteredPackages.length > 0 ? (
                filteredPackages.map((pkg, index) => (
<div className='col-lg-6 col-12 my-2'>
<div className='package-outer'>
<span className='package-span'>{pkg.day} Days {pkg.night} Night</span>

<img src={`https://api.shaktitours.com/uploads/${pkg.image}`} className='img-fluid' />
<div className='px-3 py-3'>
<p className='fs-5 fw-semibold fm-dm my-0'>{pkg.pac_name}</p>
<p className='package-point mt-2'><span>Start Point<br/>{pkg.start_point}</span>
<i class="fa-solid fa-arrow-right-arrow-left fs-3 py-2 text-dark"></i><span className='text-end'>End Point<br/>{pkg.dest_point}</span></p>

<p className='text-success fw-bold'>₹{pkg.price}/person</p>

<div className='d-flex justify-content-between text-center'>
<p onClick={() => toggleSection(pkg.id, 'sightseeing')}><i class="fa-solid package-icon fa-face-smile"></i><br /><span className='package-icon-text'>Sightseeing</span></p>
<p onClick={() => toggleSection(pkg.id, 'meal')}><i class="fa-solid package-icon fa-mug-hot"></i><br /><span className='package-icon-text'>Meals</span></p>
<p onClick={() => toggleSection(pkg.id, 'accomodation')}><i class="fa-solid package-icon fa-star"></i><br /><span className='package-icon-text'>Accomodation</span></p></div>


                      {expand[pkg.id]?.sightseeing && (
  <div className='para-text'>
    <p className='fw-semibold mb-1'>Sightseeing:</p>
    {pkg.sightseeing.split('|').map((item, idx) => (
      <p key={idx} className='mb-1'>• {item.trim()}</p>
    ))}
  </div>
)}

{expand[pkg.id]?.meal && (
  <div className='para-text'>
    <p className='fw-semibold mb-1'>Meals:</p>
    {pkg.meal.split('|').map((mealItem, idx) => (
      <p key={idx} className='mb-1'>• {mealItem.trim()}</p>
    ))}
  </div>
)}

{expand[pkg.id]?.accomodation && (
  <div className='para-text'>
    <p className='fw-semibold mb-1'>Accomodation:</p>
    {pkg.accomodation.split('|').map((item, idx) => (
      <p key={idx} className='mb-1'>• {item.trim()}</p>
    ))}
  </div>
)}

{pkg.pac_description != null ? 
<p className='para-text'>Package Details: {pkg.pac_description}</p> : ''
}

<button className='nav-btn bg-black' onClick={()=> handleShowBook(pkg)}>Book Now</button>
</div>


  </div>
</div>
                ))): (
                  <div className='text-center py-4'>
<img src={EmptyTask} className='img-fluid' alt='gif task' style={{height: '12em'}} />
<p className='fw-semibold fm-dm'>No Packages Added yet.</p></div>
                )}

</div>
{/* row ends */}

          </div>
          </section>

{showBook && (
  <>
  {showBook && selectedPkg && (
              <section className='dialog-outer px-4 py-4'>
              <div className='dialog-inner py-5 col-lg-6 col-md-8 col-12 mx-auto'>

<p className='fm-dm fw-semibold fs-5 my-0'>Fill Booking Details for {selectedPkg.pac_name} Package</p>
          <p className="fw-semibold fm-dm text-success">Package Price: ₹{selectedPkg.price}</p>

      <form onSubmit={async (e) => {
        e.preventDefault();
        const total = selectedPkg.price * parseInt(bookingForm.person || 0, 10);

const payload = {
  pkgId: selectedPkg.id,
  name: bookingForm.name,
  mobile: bookingForm.mobile,
  email: bookingForm.email,
  person: bookingForm.person,
  totalPrice: bookingForm.total_price,
  booking_on: bookingForm.booking_on
};

              setLoading(true);

        try {
          const res = await fetch("https://api.shaktitours.com/book-package", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
          });
          const result = await res.json();

          if (res.ok) {
                setResponseMessage('Booking successful!');
            // alert("Booking successful!");
            setShowBook(false);
              setLoading(false);
            setBookingForm({ name: '', mobile: '', email: '', person: '' });
                setTimeout(() => {
                    setResponseMessage('');
                }, 3000);
          } else {
                setResponseMessage('Something Went Wrong.');
              setLoading(false);
                setTimeout(() => {
                    setResponseMessage('');
                }, 3000);
          }
        } catch (err) {
              setLoading(false);
          console.error(err);
        }
      }}>
        <div className="mb-2">
          <label className='package-label'>Name</label>
          <input type="text" className="pkg-control" name="name" required value={bookingForm.name} onChange={(e) => setBookingForm({ ...bookingForm, name: e.target.value })} />
        </div>
        <div className="mb-2">
          <label className='package-label'>Mobile</label>
          <input type="tel" className="pkg-control" name="mobile" maxLength={10} required value={bookingForm.mobile} onChange={(e) => setBookingForm({ ...bookingForm, mobile: e.target.value })} />
        </div>
        <div className="mb-2">
          <label className='package-label'>Email</label>
          <input type="email" className="pkg-control" name="email" required value={bookingForm.email} onChange={(e) => setBookingForm({ ...bookingForm, email: e.target.value })} />
        </div>
        <div className="mb-2">
          <label className='package-label'>No. of Persons</label>
          <input type="number" className="pkg-control" name="person" required min="1" value={bookingForm.person} onChange={(e) => setBookingForm({ ...bookingForm, person: e.target.value })} />
        </div>

        <div className="mb-2">
  <label className='package-label'>Booking Date</label>
<input
  type="datetime-local"
  className="pkg-control"
  name="booking_on"
  required
  value={bookingForm.booking_on}
  onChange={(e) => setBookingForm({ ...bookingForm, booking_on: e.target.value })}
/>


</div>


<div className="mb-2">
  <label className='package-label'>Total Price</label>
  <input
    type="text"
    className="pkg-control bg-light"
    name="total_price"
    readOnly
    value={`₹${bookingForm.total_price}`}
  />
</div>



        <div className="mt-4">
          <button type="button" className="nav-btn bg-black" onClick={() => setShowBook(false)}>Go Back</button>&nbsp;&nbsp;
          <button type="submit" className="nav-btn">Submit</button>
        </div>
      </form>
    </div>
  </section>
)}

  </>
)}


                  {responseMessage && (
                <div className="response-message d-flex justify-content-between">
                    <p className='my-0 mx-auto'>{responseMessage}</p>
                    <p className='my-0 cursor-pointer' onClick={() => setResponseMessage(false)}> &nbsp;<i class="fa-solid fa-xmark"></i></p>
                </div>)}

{loading && <Loading setLoading={setLoading} />}
    </>
  )
}

export default TourPackage
